module.exports = "https://cdn.realtymogul.com/static/media/img_MRI.308aaf32.jpg";